import { useEffect, useRef } from "react";
import { portfolioItems } from "@/mocks/home";

export default function PortfolioSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(".animate-on-scroll");
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="portfolio" ref={sectionRef} className="py-14 md:py-20 bg-gradient-to-b from-background-50 to-background-100">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-heading">
            Notre Portfolio
          </h2>
          <div className="w-24 h-1 bg-primary-500 mx-auto rounded-full"></div>
          <p className="mt-6 text-foreground-50 max-w-2xl mx-auto">
            Découvrez quelques-unes de nos réalisations qui témoignent de notre savoir-faire et de notre passion pour l'événementiel.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {portfolioItems.map((item, index) => (
            <div
              key={item.title}
              className="animate-on-scroll opacity-0 translate-y-6 transition-all duration-700 rounded-lg overflow-hidden group relative cursor-pointer"
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <img
                src={item.image}
                alt={item.alt}
                className="w-full h-80 object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center">
                <div className="text-center p-4 pb-6">
                  <h3 className="text-xl font-semibold text-foreground-50 mb-2">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}